import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _toConsumableArray from "/app/store-locator/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/app/store-locator/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/app/store-locator/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Form, List } from 'antd';
import Map from 'components/map/map';
import { List as Restaurant } from 'components/restaurant/list';
import { AddressPicker } from 'components/setup/AddressPicker';
import { OrderType } from 'core/client';
import { sortRestaurants } from 'core/modules/restaurant/restaurant.service';
import { calculateDistance } from 'core/utils/geolocation';
import Head from 'next/head';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getCoords } from 'utils/geolocation';
import { isRestaurantClosed } from 'utils/openingHours';
import Header from '../src/components/header/header'; // get Data from the server for SEO et perf purpose
// we also want to hide the restaurants request

export var __N_SSG = true;
export default function Index(_ref) {
  var _loaded$restaurants, _company$businessDeta, _company$businessDeta2;

  var loaded = _ref.loaded;
  var restaurants = (_loaded$restaurants = loaded === null || loaded === void 0 ? void 0 : loaded.restaurants) !== null && _loaded$restaurants !== void 0 ? _loaded$restaurants : [];
  var company = loaded === null || loaded === void 0 ? void 0 : loaded.company;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(''),
      search = _useState[0],
      setSearch = _useState[1];

  var _useState2 = useState(),
      location = _useState2[0],
      setLocation = _useState2[1];

  var _useState3 = useState(''),
      focused = _useState3[0],
      setFocused = _useState3[1];

  useEffect(function () {
    var getLocation = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var coordinate;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getCoords();

              case 2:
                coordinate = _context.sent;

                if (coordinate) {
                  setLocation(coordinate);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getLocation() {
        return _ref2.apply(this, arguments);
      };
    }();

    getLocation();
  }, []);
  var filteredData = useMemo(function () {
    return restaurants === null || restaurants === void 0 ? void 0 : restaurants.filter(function (data) {
      var stringifyData = JSON.stringify(data);
      return stringifyData.includes(search);
    });
  }, [search, restaurants]);
  var sortedData = useMemo(function () {
    var openRestaurants = filteredData === null || filteredData === void 0 ? void 0 : filteredData.filter(function (data) {
      return !isRestaurantClosed(data.pickUp.hours);
    });
    var closeRestaurants = filteredData === null || filteredData === void 0 ? void 0 : filteredData.filter(function (data) {
      return isRestaurantClosed(data.pickUp.hours);
    });
    var sortedRestaurants = [].concat(_toConsumableArray(sortRestaurants(openRestaurants, OrderType.PickUp, location)), _toConsumableArray(sortRestaurants(closeRestaurants, OrderType.PickUp, location)));
    return sortedRestaurants;
  }, [location, filteredData]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Header, {
      companyWebAddress: (_company$businessDeta = company === null || company === void 0 ? void 0 : (_company$businessDeta2 = company.businessDetails) === null || _company$businessDeta2 === void 0 ? void 0 : _company$businessDeta2.webAddress) !== null && _company$businessDeta !== void 0 ? _company$businessDeta : '/'
    }), /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Head, {
        children: [/*#__PURE__*/_jsx("link", {
          rel: "icon",
          type: "image/png",
          sizes: "32x32",
          href: company === null || company === void 0 ? void 0 : company.favicon
        }), /*#__PURE__*/_jsx("title", {
          children: "".concat(company === null || company === void 0 ? void 0 : company.name, " - ").concat(t('restaurant.theRestaurants'))
        }), /*#__PURE__*/_jsx("meta", {
          name: "description",
          content: t('restaurant.findAll', {
            companyName: company === null || company === void 0 ? void 0 : company.name
          })
        })]
      }), /*#__PURE__*/_jsx(Form, {
        className: "form",
        children: /*#__PURE__*/_jsx(AddressPicker, {
          onChange: function onChange(search) {
            return setSearch(search);
          },
          onGetPosition: function onGetPosition(location) {
            return setLocation(location);
          }
        })
      }), /*#__PURE__*/_jsx(Map, {
        markers: useMemo(function () {
          return sortedData === null || sortedData === void 0 ? void 0 : sortedData.map(function (data) {
            return {
              coord: data.address.coordinates,
              label: data.name,
              address: "".concat(data.address.street, ", ").concat(data.address.zipCode, " ").concat(data.address.city),
              banner: data.banner,
              id: data.id,
              slug: data.slug,
              opening: data.pickUp.hours,
              status: data.status,
              distance: location && calculateDistance(data.address.coordinates, location).toFixed(1)
            };
          });
        }, [filteredData, location]),
        markerIconUrl: company === null || company === void 0 ? void 0 : company.logo,
        onMarkerClick: useCallback(function (id, close) {
          return close ? setFocused('') : setFocused(id);
        }, []),
        focused: focused,
        location: location
      }), /*#__PURE__*/_jsx(List, {
        itemLayout: "vertical",
        size: "large",
        className: "list",
        dataSource: sortedData,
        renderItem: function renderItem(item) {
          return /*#__PURE__*/_jsx(Restaurant, {
            onClick: function onClick() {
              return setFocused(item.id);
            },
            restaurant: item,
            isFocused: focused === item.id,
            distance: location && calculateDistance(item.address.coordinates, location).toFixed(1)
          });
        }
      })]
    })]
  });
}
var Container = styled.main.withConfig({
  displayName: "pages__Container",
  componentId: "sc-5izoex-0"
})([".gm-bundled-control-on-bottom{bottom:145px !important;}background-color:#f7f7f7;padding-bottom:20px;@media screen and (min-width:750px){height:100vh;display:grid;grid-template-columns:1fr 1fr 1fr 1fr;grid-template-rows:fit-content(100%) 1fr;gap:0px 0px;grid-template-areas:'form map map map' 'list map map map';.form{grid-area:form;}.list{grid-area:list;overflow:scroll;}.map{grid-area:map;}}"]);